module.exports = __webpack_public_path__ + "static/media/OASIS.252d5dba.svg";